import { distance, type Hex, rgbToHex } from "./oklch";

/** The xterm-256 colors 16..255: a 6×6×6 cube followed by a 24-step gray ramp. */
const CUBE_STEPS = [0, 95, 135, 175, 215, 255];

export const XTERM_EXTENDED: { index: number; hex: Hex }[] = (() => {
  const out: { index: number; hex: Hex }[] = [];
  for (let r = 0; r < 6; r++)
    for (let g = 0; g < 6; g++)
      for (let b = 0; b < 6; b++) {
        out.push({
          index: 16 + r * 36 + g * 6 + b,
          hex: rgbToHex(CUBE_STEPS[r] ?? 0, CUBE_STEPS[g] ?? 0, CUBE_STEPS[b] ?? 0),
        });
      }
  for (let i = 0; i < 24; i++) {
    const v = 8 + i * 10;
    out.push({ index: 232 + i, hex: rgbToHex(v, v, v) });
  }
  return out;
})();

/**
 * Nearest color among xterm indices 16..255 (perceptual OKLab distance). Indices 0..15 are
 * skipped on purpose: they belong to the user's terminal palette and may be anything.
 */
const cache = new Map<Hex, { index: number; hex: Hex; distance: number }>();

export function nearestXterm(hex: Hex): { index: number; hex: Hex; distance: number } {
  const hit = cache.get(hex);
  if (hit) return hit;
  if (cache.size > 4096) cache.clear();
  let best = { index: 16, hex: "#000000" as Hex, distance: Number.POSITIVE_INFINITY };
  for (const candidate of XTERM_EXTENDED) {
    const d = distance(hex, candidate.hex);
    if (d < best.distance) best = { ...candidate, distance: d };
  }
  cache.set(hex, best);
  return best;
}
